import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getCDNImageUrl } from '@/helpers/cdn';

import { ScNotFoundPromotions } from '../styled';

export const NotFoundPromotions: FC = () => {
  const { t } = useTranslation();
  return (
    <ScNotFoundPromotions
      deskBackground={getCDNImageUrl('/bonuses/promoNotFoundDesk.png')}
      mobBackground={getCDNImageUrl('/bonuses/promoNotFoundMobile.png')}
    >
      <span>{t('promoNotFound')}</span>
    </ScNotFoundPromotions>
  );
};
